import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/main.css'
import { getAuthToken, getRefreshToken, isTokenExpired } from './utils/auth'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css' // Ensure Material Design Icons are loaded

// Vue Toastification (Vue 3 version)
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})

// Toast options
const toastOptions = {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
};

// Initialize the app
const app = createApp(App)
document.title = 'Expert Panel'

// Async initialization function to handle auth state
async function initApp() {
  // Check if we have tokens in localStorage
  const authToken = getAuthToken();
  const refreshToken = getRefreshToken();
  
  if (authToken && refreshToken) {
    // Set the tokens in the store
    store.commit('SET_TOKEN', authToken);
    store.commit('SET_REFRESH_TOKEN', refreshToken);
    
    // If token is expired, try to refresh it
    if (isTokenExpired()) {
      try {
        await store.dispatch('refreshToken');
      } catch (error) {
        console.error('Failed to refresh token on init:', error);
        store.commit('CLEAR_AUTH');
      }
    }
    
    // Only try to fetch user profile if we have valid tokens
    if (store.state.token) {
      try {
        await store.dispatch('fetchUserProfile');
      } catch (error) {
        console.error('Failed to load user profile:', error);
        // Only clear auth if it's a 401 error
        if (error.response && error.response.status === 401) {
          store.commit('CLEAR_AUTH');
        }
      }
    }
  }
  
  // Mount the app after authentication checks
  app.use(store)
    .use(router)
    .use(vuetify)
    .use(Toast, toastOptions)
    .mount('#app')
}

// Start the app
initApp(); 